export const sxStyled = theme => ({
  root: {
    // Usado en desktop. Drawer usa override propio (en renderFilterContent)
    padding: { xs: '20px', lg: '20px' },
    marginTop: { xs: '0px', lg: '30px' },
    marginRight: { xs: '0px', lg: '30px' },
    maxWidth: { xs: '100%', lg: '316px' },
    width: '100%',
    height: 'fit-content',
    background: '#FFFFFF',
    border: { xs: '0px', lg: '1px solid #E5E5E5' },
    borderRadius: '8px',
    boxShadow: { xs: 'none', lg: '0px 4px 20px 0px #e3e3e3' },
  },

  filterButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 900,
    margin: '20px 0',
  },

  filterButtonUpContainer: {
    display: 'flex',
    position: 'fixed',
    right: '1px',
    bottom: '1px',
    zIndex: 1000,
    justifyContent: 'flex-end',
  },

  buttonUpMobile: {
    marginRight: '5px',
    marginBottom: '5px',
    height: '60px',
    width: '60px',
    minWidth: '60px',
    border: '1px solid #E5E5E5',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
    borderRadius: '100px',
    backgroundColor: theme.tertiary,
    opacity: 0.5,
    fontWeight: 600,
    fontSize: '16px',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: theme.tertiary,
    },
  },

  filterButtonMobile: {
    width: '120px',
    height: '50px',
    border: '1px solid #E5E5E5',
    borderRadius: '8px',
    backgroundColor: theme.primary,
    fontWeight: 600,
    fontSize: '18px',
    color: theme.text1,
  },

  filterTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '10px',
  },

  filterBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  filterBox: {
    marginTop: '20px',
  },

  filterBoxDivider: {
    marginTop: '10px',
  },

  formControlLabel: {
    fontSize: '14px',
    color: 'black',
  },

  formControlLabelRoot: {
    fontSize: '14px',
    width: 'fit-content',
  },

  filterButtonn: {
    width: '100%',
    height: '40px',
    fontSize: '16px',
    fontWeight: 600,
    color: theme.tertiary,
    borderColor: theme.tertiary,
    backgroundColor: '#FFFFFF',
    border: `1px solid ${theme.tertiary}`,
    borderRadius: '8px',
  },
});
